<template>
  <b-row class="h-100">
    <b-col cols="12">
      <b-card class="h-100">
        <template #header>
          <i class="fa fa-edit"></i><strong>Cadastro de Dicionários</strong>
        </template>
        <b-row class="h-100">
          <b-col cols="5" class=" h-100">
            <div class="d-flex justify-content-end">
              <b-dropdown href="#"
                          variant="link"
                          toggle-class="text-decoration-none p-0 m-1"
                          no-caret
                          :disabled="!rowSelected || rowSelected.status !== 1"
                          tabindex="-1">
                <template #button-content>
                  <i class="fa fa-trash text-danger p-1" style="cursor:pointer"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="#" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
            <ag-grid-vue id="pcidic-grid"
                        class="ag-theme-alpine w-100 d-flex flex-column flex-growl-1"
                        style="height: calc(100% - 30px)"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="dicGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="dicColumnDefs"
                        :rowData="objList"
                        @rowSelected="onSelectRow"
                        @gridReady="onGridReady">
            </ag-grid-vue>
          </b-col>
          <b-col cols="7" class="h-100">
            <forms class="h-100"
                   id="form"
                   :title="'Dicionário'"
                   :showClearButton="true"
                   :showSaveButton="data.status === null || data.status === 1"
                   v-on:Clear="onClearForm"
                   v-on:Save="onSaveForm">
              <b-row class="mb-2">
                <b-col cols="2">
                  <b-form-group label="Código">
                    <b-form-input v-model="form.codigo.value"
                                  :required="form.codigo.required"
                                  :state="form.codigo.state"
                                  disabled>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Nome">
                    <b-form-input v-model="form.nome.value"
                                  :required="form.nome.required"
                                  :state="form.nome.state">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="4">
                  <b-form-group label="Entidade">
                    <v-select v-model="form.entidade.value"
                              :options="form.entidade.options"
                              :required="form.entidade.required"
                              :state="form.entidade.state"
                              :reduce="ent => ent.value"
                              @input="onSelectEntity">
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Etapa">
                    <v-select v-model="form.etapaID.value"
                              :options="form.etapaID.options"
                              :required="form.etapaID.required"
                              :state="form.etapaID.state"
                              :reduce="value => value.id"
                              :getOptionLabel="value => value.nome + ' (' + value.codigo + ') '"
                              @input="onSelectStage">
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-form-group>
                    <b-form-checkbox v-model="form.pertenceFatBasico.value" :required="form.pertenceFatBasico.required" :state="form.pertenceFatBasico.state">Pertence Fat. Básico</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-card header="Itens" class="pb-0 mb-0">
                <b-row>
                  <b-col cols="3">
                    <div v-for="(item, idx) in form.itens.value" :key="idx">
                      <b-form-input disabled v-model="item.nome"></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </forms>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Dictionaries from './dictionaries'
export default Dictionaries
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/dictionaries/dictionaries.vue